module.exports = __webpack_public_path__ + "img/bg-1.3e7689ab.jpg";